export const INPUT_NO_ELEMENT_SYSNAME = 'I_INPUT_PORT_NO';
export const DATE_FILTER_ELEMENT_SYSNAME = 'DATE_FILTER'; // Not yet create on the database. Future task
export const TIME_FILTER_ELEMENT_SYSNAME = 'TIME_FILTER'; // Not yet create on the database. Future task
export const REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE ="REPORTS_FILTER_DATE_TIME_SPECIFIC_DATE";
export const REPORTS_FILTER_DATE_TIME_DATE_RANGE ="REPORTS_FILTER_DATE_TIME_DATE_RANGE";
export const REPORTS_FILTER_DATE_TIME_CURRENT_MONTH ="REPORTS_FILTER_DATE_TIME_CURRENT_MONTH";
export const REPORTS_FILTER_DATE_TIME_CURRENT_WEEK ="REPORTS_FILTER_DATE_TIME_CURRENT_WEEK";
export const REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS ="REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS";
export const REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS ="REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS";
export const REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS ="REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS";
export const REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS ="REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS";
export const REPORTS_FILTER_DATE_TIME_LAST_MONTH ="REPORTS_FILTER_DATE_TIME_LAST_MONTH";
export const REPORTS_FILTER_DATE_TIME_LAST_WEEK ="REPORTS_FILTER_DATE_TIME_LAST_WEEK";
export const REPORTS_FILTER_DATE_TIME_LAST_YEAR ="REPORTS_FILTER_DATE_TIME_LAST_YEAR";
export const REPORTS_FILTER_DATE_TIME_TODAY ="REPORTS_FILTER_DATE_TIME_TODAY";
export const REPORTS_FILTER_DATE_TIME_YESTERDAY ="REPORTS_FILTER_DATE_TIME_YESTERDAY";
export const INPUT_IP_ELEMENT_SYSNAME = 'G_BACKGROUND_INFO';
export const REPORTS_FILTER_TIME = 'FILTER_TIME';
export const STATIC_DATE_ELEMENT: string[] = [
    REPORTS_FILTER_DATE_TIME_CURRENT_MONTH,
    REPORTS_FILTER_DATE_TIME_CURRENT_WEEK,
    REPORTS_FILTER_DATE_TIME_LAST_TWO_WEEKS,
    REPORTS_FILTER_DATE_TIME_LAST_THREE_DAYS,
    REPORTS_FILTER_DATE_TIME_LAST_FOUR_WEEKS,
    REPORTS_FILTER_DATE_TIME_LAST_SIX_MONTHS,
    REPORTS_FILTER_DATE_TIME_LAST_MONTH,
    REPORTS_FILTER_DATE_TIME_LAST_WEEK,
    REPORTS_FILTER_DATE_TIME_LAST_YEAR,
    REPORTS_FILTER_DATE_TIME_TODAY,
    REPORTS_FILTER_DATE_TIME_YESTERDAY
];
export const FILTER_INACTIVE_DAYS_30 = "FILTER_INACTIVE_DAYS_30"
export const FILTER_INACTIVE_DAYS_60 = "FILTER_INACTIVE_DAYS_60"
export const FILTER_INACTIVE_DAYS_90 = "FILTER_INACTIVE_DAYS_90"
export const FILTER_INACTIVE_DAYS_180 = "FILTER_INACTIVE_DAYS_180"
export const FILTER_INACTIVE_DAYS_365 = "FILTER_INACTIVE_DAYS_365"
export const STATIC_DAY_ELEMENT: string[] = [
    FILTER_INACTIVE_DAYS_30,
    FILTER_INACTIVE_DAYS_60,
    FILTER_INACTIVE_DAYS_90,
    FILTER_INACTIVE_DAYS_180,
    FILTER_INACTIVE_DAYS_365,
];
export const INACTIVE_DAYS_BY_SYSNAME: Record<string, string> = {
    [FILTER_INACTIVE_DAYS_30]: '30',
    [FILTER_INACTIVE_DAYS_60]: '60',
    [FILTER_INACTIVE_DAYS_90]: '90',
    [FILTER_INACTIVE_DAYS_180]: '180',
    [FILTER_INACTIVE_DAYS_365]: '365',
};
export const INACTIVE_FOR_FILTER_ELEMENT_SYSNAME = 'FILTER_INACTIVE_DAYS';
export const FILTER_TIMEOUT_5M  = "FILTER_TIMEOUT_MINUTES_5";
export const FILTER_TIMEOUT_10M = "FILTER_TIMEOUT_MINUTES_10";
export const FILTER_TIMEOUT_15M = "FILTER_TIMEOUT_MINUTES_15";
export const FILTER_TIMEOUT_30M = "FILTER_TIMEOUT_MINUTES_30";
export const FILTER_TIMEOUT_60M = "FILTER_TIMEOUT_MINUTES_60";
export const FILTER_TIMEOUT_5S   = "FILTER_TIMEOUT_SECONDS_5";
export const FILTER_TIMEOUT_10S  = "FILTER_TIMEOUT_SECONDS_10";
export const FILTER_TIMEOUT_15S  = "FILTER_TIMEOUT_SECONDS_15";
export const FILTER_TIMEOUT_30S  = "FILTER_TIMEOUT_SECONDS_30";
export const FILTER_TIMEOUT_45S  = "FILTER_TIMEOUT_SECONDS_45";
export const FILTER_TIMEOUT_60S  = "FILTER_TIMEOUT_SECONDS_60";
export const FILTER_TIMEOUT_90S  = "FILTER_TIMEOUT_SECONDS_90";
export const FILTER_TIMEOUT_120S = "FILTER_TIMEOUT_SECONDS_120";
export const FILTER_TIMEOUT_180S = "FILTER_TIMEOUT_SECONDS_180";
export const FILTER_TIMEOUT_300S = "FILTER_TIMEOUT_SECONDS_300";
export const DEFAULT_TIMEOUT_SYSNAME = FILTER_TIMEOUT_15M;
export const STATIC_TIMEOUT_ELEMENT: string[] = [
    FILTER_TIMEOUT_5S,
    FILTER_TIMEOUT_10S,
    FILTER_TIMEOUT_15S,
    FILTER_TIMEOUT_30S,
    FILTER_TIMEOUT_45S,
    FILTER_TIMEOUT_60S,
    FILTER_TIMEOUT_90S,
    FILTER_TIMEOUT_120S,
    FILTER_TIMEOUT_180S,
    FILTER_TIMEOUT_300S,
    FILTER_TIMEOUT_10M,
    FILTER_TIMEOUT_15M,
    FILTER_TIMEOUT_30M,
    FILTER_TIMEOUT_60M,
];
// Canonical seconds value for each timeout sysname. Used to normalise the mixed filter before sending to the API.
export const TIMEOUT_BY_SYSNAME: Record<string, string> = {
    [FILTER_TIMEOUT_5S]:   '5',
    [FILTER_TIMEOUT_10S]:  '10',
    [FILTER_TIMEOUT_15S]:  '15',
    [FILTER_TIMEOUT_30S]:  '30',
    [FILTER_TIMEOUT_45S]:  '45',
    [FILTER_TIMEOUT_60S]:  '60',
    [FILTER_TIMEOUT_90S]:  '90',
    [FILTER_TIMEOUT_120S]: '120',
    [FILTER_TIMEOUT_180S]: '180',
    [FILTER_TIMEOUT_300S]: '300',
    [FILTER_TIMEOUT_5M]:   '300',
    [FILTER_TIMEOUT_10M]:  '600',
    [FILTER_TIMEOUT_15M]:  '900',
    [FILTER_TIMEOUT_30M]:  '1800',
    [FILTER_TIMEOUT_60M]:  '3600',
};
// Human-readable label for each timeout sysname shown in the filter chip dropdown.
export const TIMEOUT_LABELS: Record<string, string> = {
    [FILTER_TIMEOUT_5S]:   '5 sec',
    [FILTER_TIMEOUT_10S]:  '10 sec',
    [FILTER_TIMEOUT_15S]:  '15 sec',
    [FILTER_TIMEOUT_30S]:  '30 sec',
    [FILTER_TIMEOUT_45S]:  '45 sec',
    [FILTER_TIMEOUT_60S]:  '1 min',
    [FILTER_TIMEOUT_90S]:  '90 sec',
    [FILTER_TIMEOUT_120S]: '2 min',
    [FILTER_TIMEOUT_180S]: '3 min',
    [FILTER_TIMEOUT_300S]: '5 min',
    [FILTER_TIMEOUT_5M]:   '5 min',
    [FILTER_TIMEOUT_10M]:  '10 min',
    [FILTER_TIMEOUT_15M]:  '15 min',
    [FILTER_TIMEOUT_30M]:  '30 min',
    [FILTER_TIMEOUT_60M]:  '60 min',
};
export const TIMEOUT_OPTIONS = STATIC_TIMEOUT_ELEMENT.map((elementSysname) => ({
    label: TIMEOUT_LABELS[elementSysname],
    value: TIMEOUT_BY_SYSNAME[elementSysname],
    elementSysname,
}));
export const FILTER_RESULT_PASS = "FILTER_RESULT_PASS";
export const FILTER_RESULT_FAIL = "FILTER_RESULT_FAIL";
export const FILTER_RESULT_INCOMPLETE = "FILTER_RESULT_INCOMPLETE";
export const RESULT_OPTIONS = [
    { label: "Pass", value: "PASS", elementSysname: FILTER_RESULT_PASS },
    { label: "Fail", value: "FAIL", elementSysname: FILTER_RESULT_FAIL },
    { label: "Incomplete", value: "INCOMPLETE", elementSysname: FILTER_RESULT_INCOMPLETE },
];
export const MOB_STID_ENABLED: string = "MOB_STID_ENABLED";
export const MOB_STID_CARD_TOGGLE: string = "MOB_STID_CARD_TOGGLE";
export const MOB_STID_CARD_DISTANCE: string = "MOB_STID_CARD_DISTANCE";
export const MOB_STID_HANDS_FREE_TOGGLE: string = "MOB_STID_HANDS_FREE_TOGGLE";
export const MOB_STID_HANDS_FREE_DISTANCE: string = "MOB_STID_HANDS_FREE_DISTANCE";
export const MOB_STID_TAP_TAP_TOGGLE: string = "MOB_STID_TAP_TAP_TOGGLE";
export const MOB_STID_TAP_TAP_DISTANCE: string = "MOB_STID_TAP_TAP_DISTANCE";
export const MOB_STID_REMOTE_TOGGLE: string = "MOB_STID_REMOTE_TOGGLE";
export const MOB_STID_REMOTE_DISTANCE: string = "MOB_STID_REMOTE_DISTANCE";
export const MOB_STID_SMART_UNLOCK: string = "MOB_STID_SMART_UNLOCK";
export const MOB_STID_VCARD_NUM_BYTES: string = "MOB_STID_VCARD_NUM_BYTES";
export const MOB_STID_VCARD_OFFSET: string = "MOB_STID_VCARD_OFFSET";
export const MOB_STID_REVERSE_BYTES: string = "MOB_STID_REVERSE_BYTES";
export const MOB_STID_BLE_NFC: string = "MOB_STID_BLE_NFC";
export const MOB_TX_POWER: string = "MOB_TX_POWER";
export const MOB_STID_REMOTE_BUTTON: string = "MOB_STID_REMOTE_BUTTON";
export const MOB_STID_SITE_CODE: string = "MOB_STID_SITE_CODE";
export const MOB_STID_SITE_CODE_TYPE: string = "MOB_STID_SITE_CODE_TYPE";
export const MOB_HID_ENABLED: string = "MOB_HID_ENABLED";
export const MOB_HID_TWIST_TOGGLE: string = "MOB_HID_TWIST_TOGGLE";
export const MOB_HID_TWIST_RSSI: string = "MOB_HID_TWIST_RSSI";
export const MOB_HID_TAP_TOGGLE: string = "MOB_HID_TAP_TOGGLE";
export const MOB_HID_TAP_RSSI: string = "MOB_HID_TAP_RSSI";
export const MOB_HID_REMOTE_TOGGLE: string = "MOB_HID_REMOTE_TOGGLE";
export const MOB_HID_REMOTE_RSSI: string = "MOB_HID_REMOTE_RSSI";
export const MOB_HID_REVERSE_BYTES: string = "MOB_HID_REVERSE_BYTES";